import { getAdminRoleAccess } from "./adminAccess";

export const getAdminDefaultRoute = (user) => {
  if (user?.type !== "admin") return "/login";

  const roleAccess = getAdminRoleAccess(user?.role);
  if (!roleAccess) return "/background/gate/login";

  return roleAccess.defaultRoute || "/background/gate/login";
};
